import { authFetch, operaApiHeaders } from "@/modules/auth/api/authApi";
import type { AppNotification } from "@/types";

const BASE = "/api/notifications/index.php";

async function parseJson<T>(res: Response): Promise<T> {
  const data = (await res.json()) as T & { error?: string; ok?: boolean; success?: boolean };
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || `Request failed (${res.status})`);
  }
  return data;
}

export const notificationService = {
  async list(filter: "all" | "unread" = "all"): Promise<{
    notifications: AppNotification[];
    unreadCount: number;
  }> {
    const url = `${BASE}?route=list&filter=${encodeURIComponent(filter)}&limit=50`;
    const res = await authFetch(url, { headers: operaApiHeaders(false) });
    const data = await parseJson<{
      notifications?: AppNotification[];
      unreadCount?: number;
    }>(res);
    return {
      notifications: data.notifications ?? [],
      unreadCount: data.unreadCount ?? 0,
    };
  },

  async unreadCount(): Promise<number> {
    const res = await authFetch(`${BASE}?route=unread-count`, {
      headers: operaApiHeaders(false),
    });
    const data = await parseJson<{ unreadCount?: number }>(res);
    return data.unreadCount ?? 0;
  },

  async markRead(id: string): Promise<AppNotification | null> {
    const res = await authFetch(`${BASE}?route=mark-read`, {
      method: "POST",
      headers: operaApiHeaders(true),
      body: JSON.stringify({ id }),
    });
    const data = await parseJson<{ notification?: AppNotification }>(res);
    return data.notification ?? null;
  },

  async markAllRead(): Promise<void> {
    const res = await authFetch(`${BASE}?route=mark-all-read`, {
      method: "POST",
      headers: operaApiHeaders(true),
      body: JSON.stringify({}),
    });
    await parseJson(res);
  },
};
